import { domains } from "../domain/adapters.js";

export const contextualViews = [
  {
    id: "decision",
    label: "Decision",
    icon: "Compass",
    description: "Score options, inspect gates, and export the active decision receipt."
  },
  {
    id: "evidence",
    label: "Evidence",
    icon: "FileSearch",
    description: "Review evidence, missing proof, blocked claims, and source-grounded quotes."
  },
  {
    id: "equations",
    label: "Equations",
    icon: "Sigma",
    description: "Inspect operator versions, lifecycle states, and promotion blockers."
  },
  {
    id: "scenarios",
    label: "Scenarios",
    icon: "FlaskConical",
    description: "Review validation fixtures and calibration metrics without predictive claims."
  },
  {
    id: "receipts",
    label: "Receipts",
    icon: "ScrollText",
    description: "Inspect local decision receipts and generated custody artifacts."
  },
  {
    id: "readiness",
    label: "Readiness",
    icon: "ShieldCheck",
    description: "Check release proof, custody proof, and production blockers."
  }
];

const operatingSections = [
  {
    id: "source-vault",
    label: "Source Vault",
    icon: "Library",
    defaultView: "evidence",
    description: "Corpus custody, quote lawfulness, and source-lane inspection."
  },
  {
    id: "equation-workbench",
    label: "Equation Workbench",
    icon: "Sigma",
    defaultView: "equations",
    description: "Versioned operator governance and property-spec alignment."
  },
  {
    id: "receipt-ledger",
    label: "Receipt Ledger",
    icon: "ScrollText",
    defaultView: "receipts",
    description: "Decision receipts, release receipts, drift, and custody."
  },
  {
    id: "release-readiness",
    label: "Release Readiness",
    icon: "ShieldCheck",
    defaultView: "readiness",
    description: "Cloudflare proof, server custody proof, and blocked production claims."
  }
];

export const primaryNavigation = [
  ...domains.map((domain) => ({
    id: domain.id,
    label: domain.label,
    icon: domain.id === "trading" ? "TrendingUp" : domain.id === "personal" ? "UserRound" : "Compass",
    type: "domain",
    domainId: domain.id,
    defaultView: "decision",
    description: domain.objective
  })),
  ...operatingSections.map((section) => ({
    ...section,
    type: "section"
  }))
];

export const safeRouteIdPattern = /^[a-z0-9][a-z0-9-]*$/;

export function primaryItemForId(id) {
  return primaryNavigation.find((item) => item.id === id) ?? primaryNavigation[0];
}

export function contextualViewForId(id) {
  return contextualViews.find((view) => view.id === id) ?? contextualViews[0];
}

export function contextualViewsForPrimary(primaryItem) {
  if (primaryItem?.type === "section") {
    return contextualViews.filter((view) =>
      primaryItem.defaultView === "evidence"
        ? ["evidence", "receipts", "readiness"].includes(view.id)
        : ["equations", "scenarios", "receipts", "readiness"].includes(view.id)
    );
  }

  return contextualViews;
}
